<template>
    <div id="app">
        <main-header nowtab="bbs"></main-header>
        <main class="adjuster">
            <div>
                
            </div>
            <a-card
                class="card record-card"
                :tab-list="tabList"
                :active-tab-key="$route.name"
                @tabChange="change"
            >
                <router-view></router-view>
            </a-card>
            <div v-show="hasLogin" id="editor">
                <div>
                    <a-input-group compact class="titleInput">
                        <a-select v-model="toboard" dropdownClassName="boardSelector">
                            <a-select-option value="交流">
                                交流
                            </a-select-option>
                            <a-select-option value="灌水">
                                灌水
                            </a-select-option>
                        </a-select>
                        <a-input v-model="title" />
                    </a-input-group>
                </div>
                <wang-editor v-model="editorData"></wang-editor>
                <a-button type="primary" id="post" :loading="posting"
                    @click="dopost()"
                >发布</a-button>
            </div>
            <a-result v-show="!hasLogin" title="尚未登录，请登录后发帖">
                <template #icon></template>
                <template #extra>
                <a-button type="primary">
                    <a href="/login">登录</a>
                </a-button>
                </template>
            </a-result>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import WangEditor from '@/components/WangEditor'
import axios from 'axios';
import { mapState } from 'vuex';
import { createFormData } from '../../utils/utils';

export default {
    data: () => ({
        tabList: [
            { key: '0', tab: '全部' },
            { key: '1', tab: '交流' },
            { key: '2', tab: '灌水' },
        ],
        posting: false,
        editorData: "",
        title: "",
        toboard: "交流",
    }),
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
    },
    methods: {
        change(key) {
            this.$router.push({ name: key });
        },
        dopost() {
            this.posting = true;
            if (this.title == "") {
                alert("请输入标题！");
                return;
            }
            let content = this.editorData;
            content = content.replace(/&/g, "&amp;");
            if (content == "" || content == "<br>") {
                alert("请填写帖子内容！");
                return;
            }

            axios.post("/backend/bbs/post.php", createFormData({
                bid: this.toboard == "交流" ? 1 : 2,
                tid: -1,
                text: content,
                title: this.title
            })).then(({ data }) => {
                this.posting = false;
                if (data.code == 0) {
                    this.$message.success('发布成功');
                    this.$router.push(this.$route);
                } else
                    alert("错误：" + data.msg);
            });
        },
    },
    components: {
        MainHeader, Footer, WangEditor
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
#editor {
    margin-top: 20px;
    text-align: left;
}
.editorContainer {
    margin: 10px 0px;
    cursor: text;
}
.adjuster {
    max-width: 1000px;
    margin: 20px auto;
}
#post {
    margin-left: 15px;
}
.ant-pagination.top-pager {
    margin-top: 10px;
    margin-bottom: -10px;
}
.ant-select-dropdown.boardSelector {
    z-index: 10001;
}
</style>

<style lang="less">
.titleInput.ant-input-group.ant-input-group-compact {
    white-space: nowrap;
    .ant-select {
        width: 75px;
    }
    .ant-input {
        width: calc(100% - 74px);
    }
}
</style>